module.exports = __webpack_public_path__ + "media/npc_dota_hero_armadillo.20d21944.webm";